module.exports = __webpack_public_path__ + "img/scanner-keyboard.58f392a6.svg";